import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import { Dialog } from "primereact/dialog";

function withParams(Component) {
    return (props) => <Product {...props} params={useParams()} />;
}

class Product extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            product: {},
            selectProduct: {},
            quantity: 1,
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            const response = await productService.getById(this.props.params.id);

            if (response.status === 200) {
                var selectProduct;

                if (response.data.childProducts !== undefined) {
                    selectProduct = response.data.childProducts.sort(
                        (a, b) => a.amount - b.amount
                    )[0];
                } else {
                    selectProduct = response.data;
                }

                this.setState({ product: response.data, selectProduct: selectProduct });
            } else {
                alert("ERRO AO CARREGAR PAGINA");
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    banners = [
        {
            url: Banner001,
        },
        {
            url: Banner001,
        },
        {
            url: Banner001,
        },
    ];

    listPrices(product) {
        if (product.childProducts !== undefined) {
            return product.childProducts
                .sort((a, b) => a.amount - b.amount)
                .map((p) => (
                    <button
                        onClick={() => this.setState({ selectProduct: p })}
                        style={{
                            border: "1px solid #3032A3",
                            color: p.id === this.state.selectProduct.id ? "#3032A3" : "#797979",
                            padding: "6px 12px",
                            borderRadius: "30px",
                            backgroundColor:
                                p.id === this.state.selectProduct.id ? "#C4C5E5" : "#eeeeee",
                            
                            cursor: "pointer",
                            fontWeight: p.id === this.state.selectProduct.id ? "600" : "400",
                            transition: "all 0.3s ease",
                            fontSize: "12px"
                        }}
                    >
                        R${p.amount}
                    </button>
                ));
        } else {
            return (
                <button
                    style={{
                        border: "1px solid #3032A3",
                        color: "#3032A3",
                        padding: "6px 12px",
                        borderRadius: "30px",
                        backgroundColor: "#C4C5E5",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: "12px"
                    }}
                >
                    R${product.amount}
                </button>
            );
        }
    }

    addShoppingCart = async () => {
        try {
            showProcess();

            if (UserSession !== null && UserSession !== undefined) {
                var response = await shoppingCartService.addProduct(
                    this.state.selectProduct.id,
                    this.state.quantity
                );

                if (response.status === 200) {
                    this.setState({ showMessageSucess: true });

                    this.props.refreshCart();
                } else {
                    alert("Usuário ou senha inválidos.");
                }
            } else {
                var shoppingcart = JSON.parse(localStorage.getItem("shoppingCart"));

                if (shoppingcart === null || shoppingcart === undefined) {
                    shoppingcart = { lines: [] };
                }

                const date = new Date();

                var shoppingCartLine = {
                    product: this.state.selectProduct,
                    quantity: this.state.quantity,
                    amount: this.state.selectProduct.amount,
                    totalAmount: this.state.selectProduct.amount * this.state.quantity,
                    createdAt: date,
                    alteredAt: date,
                };

                shoppingcart.lines.push(shoppingCartLine);

                await localStorage.setItem("shoppingCart", JSON.stringify(shoppingcart));

                this.props.refreshCart();

                this.setState({ showMessageSucess: true });
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }

        hideProcess();
    };

    render() {
        // Extrair valores mín e máx dos preços
        let minPrice = 0, maxPrice = 0;
        if (this.state.product.childProducts) {
            const prices = this.state.product.childProducts.map(p => p.amount);
            minPrice = Math.min(...prices);
            maxPrice = Math.max(...prices);
        } else if (this.state.product.amount) {
            minPrice = maxPrice = this.state.product.amount;
        }

        return (
            <>
                {/* BREADCRUMB */}
                <div>
                    <a href="/" style={{ color: "rgb(11, 156, 229)", textDecoration: "none", marginRight: "10px", textDecoration: "underline" }}>Home</a>
                    <span style={{ color: "rgb(11, 156, 229)", marginRight: "10px" }}>|</span>
                    <a href="/store" style={{ color: "rgb(11, 156, 229)", textDecoration: "none", marginRight: "10px", textDecoration: "underline" }}>Produtos</a>
                    <span style={{ color: "rgb(11, 156, 229)", marginRight: "10px" }}>|</span>
                    <span style={{ color: "rgb(11, 156, 229)", textDecoration: "underline" }}>{this.state.product.displayName}</span>
                </div>

                {/* CONTAINER PRINCIPAL */}
                <div style={{ padding: "40px 0px", margin: "0 auto", width: "100%" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr", gap: "60px", alignItems: "start" }}>
                        
                        {/* COLUNA ESQUERDA: IMAGEM */}
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", flexDirection: "column" }}>
                            <img
                                src={`${this.state.fileServer}/cards/${this.state.product.id}.png`}
                                alt={this.state.product.displayName}
                                style={{
                                    width: "100%",
                                    maxWidth: "350px",
                                    borderRadius: "15px",
                                    objectFit: "contain",
                                }}
                            />
                            {/* DESCRIÇÃO */}
                            <div style={{ marginTop: "10px"}}>
                                <p style={{
                                    fontSize: "16px",
                                    color: "#666",
                                    lineHeight: "1.6",
                                    maxWidth: "600px"
                                }}>
                                    Dê liberdade de escolha com este Cartão Presente Multimarcas.
                                    <br /><br />
                                    Com diversas marcas disponíveis, é um presente prático, versátil e perfeito para quem quer agradar sem errar, oferecendo uma experiência única no mundo dos jogos.
                                </p>
                            </div>
                        </div>

                        {/* COLUNA DIREITA: INFORMAÇÕES */}
                        <div>
                            {/* Badge */}
                            <div style={{
                                display: "inline-block",
                                backgroundColor: "#0099ff",
                                color: "yellow",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                fontSize: "9px",
                                fontWeight: "600",
                                marginBottom: "0px"
                            }}>
                                O melhor<br/>presente para
                            </div>

                            {/* Título */}
                            <h1 style={{
                                fontSize: "32px",
                                color: "#000141",
                                margin: "5px 0 10px 0",
                                fontWeight: "700",
                                fontFamily: "Montserrat, sans-serif"
                            }}>
                                {this.state.product.displayName}
                            </h1>

                            {/* Subtítulo */}
                            <p style={{
                                fontSize: "18px",
                                color: "#666",
                                margin: "0 0 20px 0",
                                fontWeight: "400"
                            }}>
                                Cartão-Presente Digital
                            </p>

                            {/* Valores */}
                            <div style={{ marginBottom: "15px" }}>
                                <p style={{
                                    fontSize: "14px",
                                    color: "#000141",
                                    margin: "0 0 12px 0",
                                    fontWeight: "600",
                                }}>
                                    Valores (R${minPrice} - R${maxPrice})
                                </p>
                                <div style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    borderTop: "1px solid #C4C5E5",
                                    paddingTop: "15px"
                                }}>
                                    {this.listPrices(this.state.product)}
                                </div>
                            </div>

                            
                        </div>

                        {/* COLUNA ESQUERDA: IMAGEM */}
                        <div style={{ display: "flex", width: "fit-content", justifyContent: "center", alignItems: "center", flexDirection: "column", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "15px" }}>
                            {/* Quantidade */}
                            <div style={{ marginBottom: "30px", textAlign: "center" }}>
                                <p style={{
                                    fontSize: "14px",
                                    color: "#666",
                                    margin: "0 0 12px 0",
                                    fontWeight: "600"
                                }}>
                                    Quantidade
                                </p>
                                <InputNumber
                                    className="input-quantity-product"
                                    value={this.state.quantity}
                                    onValueChange={(e) => this.setState({ quantity: e.value })}
                                    showButtons
                                    buttonLayout="horizontal"
                                    step={1}
                                    incrementButtonIcon="pi pi-plus"
                                    decrementButtonIcon="pi pi-minus"
                                    min={1}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    max={50}
                                    mode="decimal"
                                inputStyle={{textAlign: "center"}}
                                    
                                />
                            </div>

                            {/* Botão Adicionar */}
                            <button
                                onClick={() => this.addShoppingCart()}
                                style={{
                                    width: "100%",
                                    backgroundColor: "#411172",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "30px",
                                    padding: "12px 26px",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    fontFamily: "Montserrat, sans-serif",
                                    maxWidth: "250px"
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = "#2a0b4d"}
                                onMouseLeave={(e) => e.target.style.backgroundColor = "#411172"}
                            >
                                Adicionar no carrinho
                            </button>
                        </div>
                    </div>

                    
                </div>

                {this.state.showMessageSucess && (
                    <Dialog visible={true} closable={false}>
                        <div style={{ textAlign: "center" }}>
                            <label style={{ fontSize: "17px" }}>
                                Produto adicionado ao carrinho.
                            </label>
                            <br />
                            <br />
                            <button
                                onClick={() => (window.location.href = "/store")}
                                style={{
                                    marginTop: "15px",
                                    backgroundColor: "#000141",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "25px",
                                    padding: "12px 25px",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                Continuar Comprando
                            </button>
                            <br />
                            <button
                                onClick={() => (window.location.href = "/cart")}
                                style={{
                                    marginTop: "15px",
                                    backgroundColor: "#fff",
                                    border: "1px solid #000141",
                                    color: "#000141",
                                    borderRadius: "25px",
                                    padding: "12px 25px",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                Ir para o carrinho
                            </button>
                        </div>
                    </Dialog>
                )}
            </>
        );
    }
}

export default withParams(Product);
